export class CenterGroup{
    id: any;
    nombre: string;
}